import { feedbackConstants } from "../_constants";
import { feedbackService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const feedbackActions = {
  submitFeedback
};

function submitFeedback(user, values) {
  return dispatch => {
    dispatch(request());

    feedbackService.submitFeedback(user, values).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: feedbackConstants.SUBMIT_REQUEST };
  }
  function success(detail) {
    return { type: feedbackConstants.SUBMIT_SUCCESS, detail };
  }
  function failure(error) {
    return { type: feedbackConstants.SUBMIT_FAILURE, error };
  }
}
